<template>
  <!-- 内容管理-投保流程 -->
  <div>
    <Form ref="form" :model="formData" class="page-form" :label-width="60" v-if="productForm.sourceType == 2">
      <FormItem label="类型" class="full">
        <RadioGroup v-model="formData.type" @on-change="typeChange">
          <Radio label="1">自定义内容</Radio>
          <Radio label="2">外部链接</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="地址" class="full" prop="url" v-if="formData.type == 2">
        <Input type="text" v-model="formData.url" placeholder="请输入" @on-change="saveLink"/>
      </FormItem>
    </Form>
    <div class="tools-box left" v-if="formData.type == 1 && productForm.sourceType == 2 && productForm.dockChannel != 3">
      <Button type="primary" @click="$refs.productProcessForm.open({stepSeq:maxIndex+1})">新增</Button>
    </div>
    <div class="table-box" v-if="formData.type == 1||productForm.sourceType == 1">
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData">
        <template slot-scope="{ row, index }" slot="action">
          <template v-if="productForm.sourceType == 1">
            <span class="table-btn" :class="{ 'disabled': productForm.dockChannel == 3 }" @click="$refs.productProcessForm.open(row, false)">详情</span>
          </template>
          <template v-else>
            <span v-if="index != 0 && productForm.dockChannel != 3" class="table-btn" @click="moveUp(index)"><i class="iconfont iconyidong-xiangshang"></i></span>
            <span v-if="tableData.length != index + 1 && productForm.dockChannel != 3" class="table-btn" @click="moveDown(index)"><i class="iconfont iconyidongxiangxia"></i></span>
            <span class="table-btn" :class="{ 'disabled': productForm.dockChannel == 3 }" @click="$refs.productProcessForm.open(row, true)">编辑</span>
            <span class="table-btn red" :class="{ 'disabled': productForm.dockChannel == 3 }" @click="del(row)">删除</span>
          </template>
        </template>
      </Table>
    </div>

    <!-- 新增/编辑流程表单 -->
    <product-process-form ref="productProcessForm" @reload="getProductProcess" :productForm="productForm"></product-process-form>
    <!-- 确认弹窗 -->
    <confirm-Modal ref="confirmModal"></confirm-Modal>
  </div>
</template>

<script>
import productProcessForm from './productProcessForm';
import confirmModal from '@/components/commons/confirmModal';
import _ from 'lodash';
export default {
  components: {
    productProcessForm,
    confirmModal
  },
  props: {},
  data() {
    return {
      listLoading: false,
      maxIndex:"",
      formData: {
        type:'',
      },
      productForm: {},
      tableData: [],
      columns: [
        {
          title: '步骤',
          type: 'index',
          width: 80,
          align: 'center'
        },
        {
          title: '名称',
          key: 'stepName',
          width: 100,
          align: 'center'
        },
        {
          title: '介绍',
          key: 'describe',
          minWidth: 300,
          align: 'center'
        },
        {
          title: '操作',
          slot: 'action',
          width: 180,
          align: 'center'
        }
      ]
    };
  },
  mounted() {},
  methods: {
    init(productForm) {
      this.productForm = productForm;
      if(this.productForm.sourceType == 1) {//平台产品
        this.formData.type = this.productForm.insureProfileType;
      } else if(!this.productForm.insureProfileType) {
        this.formData.type = '1';
        return;
      } else {
        this.formData.type = this.productForm.insureProfileType;
      }
      this.getProductProcess();
    },
    // 获取投保流程
    getProductProcess() {
      return this.$http({
        url: '/buz/productInsureProfile/offline/list',
        type: 'GET',
        data: {
          productCode: this.productForm.productCode,
          type: this.formData.type
        }
      }).then(res => {
        this.tableData = res.data;
        if (this.tableData.length) {
          this.formData = this.tableData[0];
          const lastData = this.tableData.slice(-1);
          this.maxIndex = lastData[0].stepSeq;
        } else {
          this.formData.id = '';
          this.formData.url = '';
          this.maxIndex = 0;
        }
      });
    },
    // 修改类型
    typeChange(){
      this.$http({
        url: '/buz/productInsureProfile/offline/update',
        type: 'POST',
        data: {
          productId: this.productForm.id,
          productCode: this.productForm.productCode,
          type: this.formData.type,
        }
      }).then(res => {
        this.productForm.insureProfileType = this.formData.type;
        this.getProductProcess();
      });
    },
    // 上移
    async moveUp(index) {
      const list = this.tableData;
      const arr = [list[index - 1],list[index]]
      const index1 = arr[0].stepSeq;
      const index2 = arr[1].stepSeq;
      arr[0].stepSeq = index2;
      arr[1].stepSeq = index1;
      const close = this.$notice.loading('加载中');
      await this.saveIndex(arr[0]);
      await this.saveIndex(arr[1]);
      await this.getProductProcess();
      close()
    },
    // 下移
    async moveDown(index) {
      const list = this.tableData;
      const arr = [list[index],list[index + 1]]
      const index1 = arr[0].stepSeq;
      const index2 = arr[1].stepSeq;
      arr[0].stepSeq = index2;
      arr[1].stepSeq = index1;
      const close = this.$notice.loading('加载中');
      await this.saveIndex(arr[0]);
      await this.saveIndex(arr[1]);
      await this.getProductProcess();
      close()
    },
    // 保存顺序
    saveIndex(data){
      return this.$http({
        url: '/buz/productInsureProfile/edit',
        type: 'POST',
        data: {
          id:data.id,
          stepSeq:data.stepSeq,
        }
      })
    },
    // 删除
    del(bean) {
      this.$refs.confirmModal
        .open({
          title: '提示',
          content: '请确认是否删除？'
        })
        .then(async () => {
          this.$http({
            url: '/buz/productInsureProfile/del',
            type: 'POST',
            data: {
              productId: this.productForm.id,
              ids:[bean.id]
            }
          }).then(res=>{
            this.getProductProcess();
          })
        });
    },
    // 保存外链
    saveLink:_.debounce(function () {
      this.$http({
        url: '/buz/productInsureProfile/offline/update',
        type: 'POST',
        data: {
          type: 2,
          productId: this.productForm.id,
          productCode: this.productForm.productCode,
          productInsureProfile: {
            productId: this.productForm.id,
            productCode: this.productForm.productCode,
            id: this.formData.id,
            type: 2,
            url: this.formData.url
          }
        }
      }).then(res => {
        this.getProductProcess();
      });
    }, 500)
  }
};
</script>
<style lang="scss" scoped>
</style>